<template>
  <div class="page-table-fprm-No">
    <a-form
      layout="inline"
      :form="form"
      @submit="handleSubmit"
      class="page-form-queryhederNo"
    >
      <a-form-item label="工厂名称">
        <a-input v-decorator="['company']" placeholder="工厂名称"> </a-input>
      </a-form-item>
      <a-form-item label="产品货号">
        <a-input v-decorator="['company']" placeholder="产品货号"> </a-input>
      </a-form-item>
      <a-form-item label="产品订单号">
        <a-input v-decorator="['company']" placeholder="产品订单号"> </a-input>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" html-type="submit">
          搜索
        </a-button>
      </a-form-item>
    </a-form>
    <a-table
      :columns="columns"
      :dataSource="data"
      :scroll="{ x: 1500, y: 300 }"
      style="
         width: 97%;
         margin: 20px;
        border: 1px solid #dbdbdb"
    >
      <a-button
        slot="actionOne"
        type="primary"
        slot-scope="record"
        @click="action(record)"
        >立即支付</a-button
      >
      <a-button
        slot="actionTow"
        type="default"
        slot-scope="record"
        @click="action(record)"
        >取消订单</a-button
      >
    </a-table>
  </div>
</template>
<script>
const columns = [
  {
    title: '序号',
    align: 'center',
    width: '120px',
    fixed: 'left',
    customRender: (text, record, index) => `${index + 1}`,
  },
  {
    title: '款号型号',
    dataIndex: 'phone',
    key: 'phone',
    width: '200px',
    fixed: 'left',
    align: 'center',
  },
  {
    title: '工厂联系人',
    dataIndex: 'eMail',
    key: 'eMail',
    align: 'center',
  },
  {
    title: '计费单位',
    dataIndex: 'company',
    key: 'company',
    width: '12%',
    align: 'center',
  },
  {
    title: '实付金额',
    key: 'money',
    dataIndex: 'money',
    width: '10%',
    align: 'center',
  },
  {
    title: '订单状态',
    key: 'adress',
    dataIndex: 'adress',
    width: '14%',
    align: 'center',
  },
  {
    title: '操作时间',
    key: 'sales',
    dataIndex: 'sales',
    width: '10%',
    align: 'center',
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    width: 100,
    scopedSlots: { customRender: 'actionOne' },
    // width: '14%',
    align: 'center',
  },
];
const data = [
  {
    key: '1',
    phone: '18153225436',
    eMail: '56654666@qq.com',
    company: '光大',
    money: 0.0,
    adress: '意大利',
    sales: '',
    grade: 4.5,
  },
  {
    key: '2',
    phone: '18153225436',
    eMail: '56654666@qq.com',
    company: '光大',
    money: 0.0,
    adress: '意大利',
    sales: '',
    grade: 4.5,
  },
  {
    key: '3',
    phone: '18153225436',
    eMail: '56654666@qq.com',
    company: '光大',
    money: 0.0,
    adress: '意大利',
    sales: '',
    grade: 4.5,
  },
  {
    key: '4',
    phone: '18153225436',
    eMail: '56654666@qq.com',
    company: '光大',
    money: 0.0,
    adress: '意大利',
    sales: '',
    grade: 4.5,
  },
  {
    key: '5',
    phone: '18153225436',
    eMail: '56654666@qq.com',
    company: '光大',
    money: 0.0,
    adress: '意大利',
    sales: '',
    grade: 4.5,
  },
  {
    key: '6',
    phone: '18153225436',
    eMail: '56654666@qq.com',
    company: '光大',
    money: 0.0,
    adress: '意大利',
    sales: '',
    grade: 4.5,
  },
  {
    key: '7',
    phone: '18153225436',
    eMail: '56654666@qq.com',
    company: '光大',
    money: 0.0,
    adress: '意大利',
    sales: '',
    grade: 4.5,
  },
  {
    key: '8',
    phone: '18153225436',
    eMail: '56654666@qq.com',
    company: '光大',
    money: 0.0,
    adress: '意大利',
    sales: '',
    grade: 4.5,
  },
  {
    key: '9',
    phone: '18153225436',
    eMail: '56654666@qq.com',
    company: '光大',
    money: 0.0,
    adress: '意大利',
    sales: '',
    grade: 4.5,
  },
  {
    key: '13',
    phone: '18153225436',
    eMail: '56654666@qq.com',
    company: '光大',
    money: 0.0,
    adress: '意大利',
    sales: '',
    grade: 4.5,
  },
  {
    key: '23',
    phone: '18153225436',
    eMail: '56654666@qq.com',
    company: '光大',
    money: 0.0,
    adress: '意大利',
    sales: '',
    grade: 4.5,
  },
  {
    key: '33',
    phone: '18153225436',
    eMail: '56654666@qq.com',
    company: '光大',
    money: 0.0,
    adress: '意大利',
    sales: '',
    grade: 4.5,
  },
];

export default {
  data() {
    return {
      form: this.$form.createForm(this),
      data,
      columns,
    };
  },
  created() {
    // console.log(this.form);
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values);
        }
      });
    },

    action(record) {
      console.log(record);
      this.$router.push({
        path: '/client/clientDetails',
        query: {
          key: record.key,
        },
      });
    },
    /*下拉*/
    handleChange(value) {
      // this.add()
      console.log(`selected ${value}`);
    },
    /*检验时间*/
    onDateChange(date, dateString) {
      console.log(date, dateString);
    },
  },
};
</script>
<style lang="less">
.page-table-fprm-No {
  padding-top: 10px;
  padding-bottom: 40px;
  border-left: 3px solid #f0f2f5;
  border-right: 2px solid #f0f2f5;
  border-bottom: 2px solid #a7a7a7;
  border-radius: 10px;
  margin-top: 3%;
  .page-form-queryhederNo {
    border-radius: 10px;
    border-bottom: 2px solid #a2a2a2;
    border-left: 1px solid #dbdbdb;
    border-right: 1px solid #dbdbdb;
    width: 97%;
    margin: 20px;
  }
}
</style>
